<template>
  <div class="detailed">
    <div class="detailed__grid">
      <div />
      <div class="d-flex flex-column">
        <strong>Free</strong>
        <h6 class="text-primary">0,-</h6>
      </div>
      <div class="d-flex flex-column">
        <strong>Basic</strong>
        <h6 class="text-primary">Kr 99/måned</h6>
      </div>
      <div class="d-flex flex-column">
        <strong>Premium</strong>
        <h6 class="text-primary">Kr 199/måned</h6>
      </div>
    </div>
    <hr />

    <div v-for="(benefit, index) in benefits" :key="index" class="detailed__grid -content">
      <span>{{ benefit.benefit }}</span>
      <div v-for="(item, index) in benefit.active" :key="index">
        <i v-if="item === false" class="h5 budicon-cross-ui" />
        <i v-else-if="item === true" class="h5 budicon-checkboxes text-primary" />
        <span v-else class="text-primary">
          {{ item }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'Detailed',
  props: {
    benefits: {
      type: Array,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped>
.detailed__grid {
  display: grid;
  grid-template-columns: 48% 1fr 1fr 1fr;
}
.detailed__grid.-content {
  padding: 1rem;
  align-items: center;
  border-bottom: 1px solid $gray-200;
}
</style>
